import { Label } from "@/components/ui/label";

export const AdminReadOnlyField = ({
    label,
    value,
    description,
}: {
    label: string;
    value?: string | number | null;
    description?: string;
}) => (
    <div className="space-y-1">
        <Label className="text-sm font-medium">{label}</Label>
        {description && (
            <p className="text-admin-primary mb-2 text-xs">{description}</p>
        )}
        <div className="bg-admin-secondary text-admin-card-foreground mt-1 rounded-md border px-3 py-2 text-sm">
            {value || "—"}
        </div>
    </div>
);
